import EmpDialogSelector from './emp-dialog-selector.vue'

EmpDialogSelector.install = function (Vue) {
	Vue.component(EmpDialogSelector.name, EmpDialogSelector);
}

export default EmpDialogSelector;